import * as _ from 'lodash';
import { TBoundAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { TDict } from '../../../../../shared/types/utilityTypes';

//
// Actions
//

type TGroupCharterClientState = {};

// team leaderboard

type TViewTeamLeaderboardRequestedParamsData = {
  region: string;
  season: string;
  bracket: string;
  eventId: number;
  faction: string;
  page: number;
  pageSize?: number;
};

type TViewTeamLeaderboardRequestedParams = {
  instanceId: string;
  params: TViewTeamLeaderboardRequestedParamsData;
};

type TViewTeamLeaderboardSucceededParamsData = TViewTeamLeaderboardRequestedParamsData & {
  results: any;
};

type TViewTeamLeaderboardSucceededParams = {
  instanceId: string;
  params: TViewTeamLeaderboardSucceededParamsData;
};

type TViewTeamLeaderboardFailedParamsData = TViewTeamLeaderboardRequestedParamsData & {
  error: any;
};

type TViewTeamLeaderboardFailedParams = {
  instanceId: string;
  params: TViewTeamLeaderboardFailedParamsData;
};

// team details

type TViewTeamDetailsRequestedParams = {
  region: string;
  team: string;
};

type TViewTeamDetailsSucceededParams = TViewTeamDetailsRequestedParams & {
  results: any;
};

type TViewTeamDetailsFailedParams = TViewTeamDetailsRequestedParams & {
  error: any;
};

// team roster

type TViewTeamRosterRequestedParams = {
  region: string;
  team: string;
};

type TViewTeamRosterSucceededParams = TViewTeamRosterRequestedParams & {
  results: any;
};

type TViewTeamRosterFailedParams = TViewTeamRosterRequestedParams & {
  error: any;
};

// team mythic plus progress

type TViewTeamMythicPlusProgressRequestedParams = {
  region: string;
  team: string;
  season: string;
};

type TViewTeamMythicPlusProgressSucceededParams = TViewTeamMythicPlusProgressRequestedParams & {
  results: any;
};

type TViewTeamMythicPlusProgressFailedParams = TViewTeamMythicPlusProgressRequestedParams & {
  error: any;
};

// team mythic plus callouts

type TViewTeamMythicPlusCalloutsRequestedParams = {
  region: string;
  team: string;
  season: string;
};

type TViewTeamMythicPlusCalloutsSucceededParams = TViewTeamMythicPlusCalloutsRequestedParams & {
  results: any;
};

type TViewTeamMythicPlusCalloutsFailedParams = TViewTeamMythicPlusCalloutsRequestedParams & {
  error: any;
};

// team mythic plus ranks

type TViewTeamMythicPlusRanksRequestedParams = {
  region: string;
  team: string;
  season: string;
};

type TViewTeamMythicPlusRanksSucceededParams = TViewTeamMythicPlusRanksRequestedParams & {
  results: any;
};

type TViewTeamMythicPlusRanksFailedParams = TViewTeamMythicPlusRanksRequestedParams & {
  error: any;
};

// team mythic plus dungeon runs

type TViewTeamMythicPlusDungeonRequestedParams = {
  region: string;
  team: string;
  season: string;
  dungeon: string;
};

type TViewTeamMythicPlusDungeonSucceededParams = TViewTeamMythicPlusDungeonRequestedParams & {
  results: any;
};

type TViewTeamMythicPlusDungeonFailedParams = TViewTeamMythicPlusDungeonRequestedParams & {
  error: any;
};

export const enum ActionTypes {
  /* RECRUITMENT */
  LOAD_TEAM_RECRUITMENT_PROFILE = 'TEAM/RECRUITMENT/LOAD_PROFILES',
  LOAD_TEAM_RECRUITMENT_PROFILE_SUCCESS = 'TEAM/RECRUITMENT/LOAD_PROFILES_SUCCESS',
  LOAD_TEAM_RECRUITMENT_PROFILE_FAIL = 'TEAM/RECRUITMENT/LOAD_PROFILES_FAIL',
  REQUEST_APPLICATION = 'TEAM/RECRUITMENT/REQUEST_APPLICATION',
  REQUEST_APPLICATION_SUCCESS = 'TEAM/RECRUITMENT/REQUEST_APPLICATION_SUCCESS',
  REQUEST_APPLICATION_FAIL = 'TEAM/RECRUITMENT/REQUEST_APPLICATION_FAIL',
  SET_APPLICATION_MSG = 'TEAM/RECRUITMENT/SET_APPLICATION_MSG',
  SET_SOURCE_PROFILE = 'TEAM/RECRUITMENT/SET_SOURCE_PROFILE',
  LOAD_OWN_PROFILE_SUCCESS = 'TEAM/RECRUITMENT/LOAD_OWN_PROFILE_SUCCESS',
  LOAD_OWN_PROFILE_FAIL = 'TEAM/RECRUITMENT/LOAD_OWN_PROFILE_FAIL',
  TOGGLE_APPLY_MODAL_VISIBILITY = 'TEAM/RECRUITMENT/TOGGLE_APP_MODAL',
  SET_TARGET_PROFILE_ID = 'TEAM/RECRUITMENT/SET_TARGET',
  /* END RECRUITMENT */

  SHOW_LOADING_SPINNER = 'GROUP_CHARTER/SHOW_LOADING_SPINNER',
  SHOW_ERROR = 'GROUP_CHARTER/SHOW_ERROR',

  SET_TEAM_LEADERBOARD_REQUESTED = 'TEAM/VIEW_LEADERBOARD_REQUESTED',
  SET_TEAM_LEADERBOARD_SUCCEEDED = 'TEAM/VIEW_LEADERBOARD_SUCCEEDED',
  SET_TEAM_LEADERBOARD_FAILED = 'TEAM/VIEW_LEADERBOARD_FAILED',

  SET_TEAM_DETAILS_REQUESTED = 'TEAM/VIEW_DETAILS_REQUESTED',
  SET_TEAM_DETAILS_SUCCEEDED = 'TEAM/VIEW_DETAILS_SUCCEEDED',
  SET_TEAM_DETAILS_FAILED = 'TEAM/VIEW_DETAILS_FAILED',

  SET_TEAM_ROSTER_REQUESTED = 'TEAM/VIEW_ROSTER_REQUESTED',
  SET_TEAM_ROSTER_SUCCEEDED = 'TEAM/VIEW_ROSTER_SUCCEEDED',
  SET_TEAM_ROSTER_FAILED = 'TEAM/VIEW_ROSTER_FAILED',

  SET_TEAM_MYTHICPLUS_PROGRESS_REQUESTED = 'TEAM/VIEW_MYTHICPLUS_PROGRESS_REQUESTED',
  SET_TEAM_MYTHICPLUS_PROGRESS_SUCCEEDED = 'TEAM/VIEW_MYTHICPLUS_PROGRESS_SUCCEEDED',
  SET_TEAM_MYTHICPLUS_PROGRESS_FAILED = 'TEAM/VIEW_MYTHICPLUS_PROGRESS_FAILED',

  SET_TEAM_MYTHICPLUS_CALLOUTS_REQUESTED = 'TEAM/VIEW_MYTHICPLUS_CALLOUTS_REQUESTED',
  SET_TEAM_MYTHICPLUS_CALLOUTS_SUCCEEDED = 'TEAM/VIEW_MYTHICPLUS_CALLOUTS_SUCCEEDED',
  SET_TEAM_MYTHICPLUS_CALLOUTS_FAILED = 'TEAM/VIEW_MYTHICPLUS_CALLOUTS_FAILED',

  SET_TEAM_MYTHICPLUS_RANKS_REQUESTED = 'TEAM/VIEW_MYTHICPLUS_RANKS_REQUESTED',
  SET_TEAM_MYTHICPLUS_RANKS_SUCCEEDED = 'TEAM/VIEW_MYTHICPLUS_RANKS_SUCCEEDED',
  SET_TEAM_MYTHICPLUS_RANKS_FAILED = 'TEAM/VIEW_MYTHICPLUS_RANKS_FAILED',

  SET_TEAM_MYTHICPLUS_SEASON = 'TEAM/SET_TEAM_MYTHICPLUS_SEASON',

  SET_TEAM_MYTHICPLUS_DUNGEON_TOGGLED = 'TEAM/SET_TEAM_MYTHICPLUS_DUNGEON_TOGGLED',

  SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_REQUESTED = 'TEAM/VIEW_MYTHICPLUS_DUNGEON_RUNS_REQUESTED',
  SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_SUCCEEDED = 'TEAM/VIEW_MYTHICPLUS_DUNGEON_RUNS_SUCCEEDED',
  SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_FAILED = 'TEAM/VIEW_MYTHICPLUS_DUNGEON_RUNS_FAILED'
}

// team leaderboard
export type TActionTeamLeaderboardRequested = TBoundAction<
  ActionTypes.SET_TEAM_LEADERBOARD_REQUESTED,
  TViewTeamLeaderboardRequestedParams
>;
type TActionTeamLeaderboardSucceeded = TBoundAction<
  ActionTypes.SET_TEAM_LEADERBOARD_SUCCEEDED,
  TViewTeamLeaderboardSucceededParams
>;
type TActionTeamLeaderboardFailed = TBoundAction<
  ActionTypes.SET_TEAM_LEADERBOARD_FAILED,
  TViewTeamLeaderboardFailedParams
>;

// team details
export type TActionTeamDetailsRequested = TBoundAction<
  ActionTypes.SET_TEAM_DETAILS_REQUESTED,
  TViewTeamDetailsRequestedParams
>;
type TActionTeamDetailsSucceeded = TBoundAction<
  ActionTypes.SET_TEAM_DETAILS_SUCCEEDED,
  TViewTeamDetailsSucceededParams
>;
type TActionTeamDetailsFailed = TBoundAction<ActionTypes.SET_TEAM_DETAILS_FAILED, TViewTeamDetailsFailedParams>;

// team roster
export type TActionTeamRosterRequested = TBoundAction<
  ActionTypes.SET_TEAM_ROSTER_REQUESTED,
  TViewTeamRosterRequestedParams
>;
type TActionTeamRosterSucceeded = TBoundAction<ActionTypes.SET_TEAM_ROSTER_SUCCEEDED, TViewTeamRosterSucceededParams>;
type TActionTeamRosterFailed = TBoundAction<ActionTypes.SET_TEAM_ROSTER_FAILED, TViewTeamRosterFailedParams>;

// team mythic plus progress
export type TActionTeamMythicPlusProgressRequested = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_REQUESTED,
  TViewTeamMythicPlusProgressRequestedParams
>;
type TActionTeamMythicPlusProgressSucceeded = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_SUCCEEDED,
  TViewTeamMythicPlusProgressSucceededParams
>;
type TActionTeamMythicPlusProgressFailed = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_FAILED,
  TViewTeamMythicPlusProgressFailedParams
>;

// team mythic plus callouts
export type TActionTeamMythicPlusCalloutsRequested = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_REQUESTED,
  TViewTeamMythicPlusCalloutsRequestedParams
>;
type TActionTeamMythicPlusCalloutsSucceeded = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_SUCCEEDED,
  TViewTeamMythicPlusCalloutsSucceededParams
>;
type TActionTeamMythicPlusCalloutsFailed = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_FAILED,
  TViewTeamMythicPlusCalloutsFailedParams
>;

// team mythic plus ranks
export type TActionTeamMythicPlusRanksRequested = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_REQUESTED,
  TViewTeamMythicPlusRanksRequestedParams
>;
type TActionTeamMythicPlusRanksSucceeded = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_SUCCEEDED,
  TViewTeamMythicPlusRanksSucceededParams
>;
type TActionTeamMythicPlusRanksFailed = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_FAILED,
  TViewTeamMythicPlusRanksFailedParams
>;

// team mythic plus dungeon runs
export type TActionTeamMythicPlusDungeonRunsRequested = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_REQUESTED,
  TViewTeamMythicPlusDungeonRequestedParams
>;
type TActionTeamMythicPlusDungeonRunsSucceeded = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_SUCCEEDED,
  TViewTeamMythicPlusDungeonSucceededParams
>;
type TActionTeamMythicPlusDungeonRunsFailed = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_FAILED,
  TViewTeamMythicPlusDungeonFailedParams
>;

// misc
type TActionTeamMythicPlusSeasonSet = TBoundAction<ActionTypes.SET_TEAM_MYTHICPLUS_SEASON, string>;

type TActionTeamMythicPlusDungeonToggled = TBoundAction<
  ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_TOGGLED,
  TViewTeamMythicPlusDungeonRequestedParams
>;

type TActionLoadRecruitmentProfiles = TBoundAction<ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE, any>;
type TActionLoadRecruitmentProilesSuccess = TBoundAction<ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE_SUCCESS, any>;
type TActionLoadRecruitmentProfilesFail = TBoundAction<ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE_FAIL, any>;
type TActionRequestApplication = TBoundAction<ActionTypes.REQUEST_APPLICATION, any>;
type TActionRequestApplicationSuccess = TBoundAction<ActionTypes.REQUEST_APPLICATION_SUCCESS, any>;
type TActionRequestApplicationFail = TBoundAction<ActionTypes.REQUEST_APPLICATION_FAIL, any>;
type TActionSetApplicationMessage = TBoundAction<ActionTypes.SET_APPLICATION_MSG, any>;
type TActionSetSourceProfile = TBoundAction<ActionTypes.SET_SOURCE_PROFILE, any>;
type TActionToggleModalVisibility = TBoundAction<ActionTypes.TOGGLE_APPLY_MODAL_VISIBILITY, any>;
type TActionSetTarget = TBoundAction<ActionTypes.SET_TARGET_PROFILE_ID, any>;
type TLocationChange = TBoundAction<typeof LOCATION_CHANGE, any>;

// recruitment

type TSupportedActions =
  | TActionTeamLeaderboardRequested
  | TActionTeamLeaderboardSucceeded
  | TActionTeamLeaderboardFailed
  | TActionTeamDetailsRequested
  | TActionTeamDetailsSucceeded
  | TActionTeamDetailsFailed
  | TActionTeamMythicPlusProgressRequested
  | TActionTeamMythicPlusProgressSucceeded
  | TActionTeamMythicPlusProgressFailed
  | TActionTeamMythicPlusCalloutsRequested
  | TActionTeamMythicPlusCalloutsSucceeded
  | TActionTeamMythicPlusCalloutsFailed
  | TActionTeamMythicPlusRanksRequested
  | TActionTeamMythicPlusRanksSucceeded
  | TActionTeamMythicPlusRanksFailed
  | TActionTeamMythicPlusDungeonRunsRequested
  | TActionTeamMythicPlusDungeonRunsSucceeded
  | TActionTeamMythicPlusDungeonRunsFailed
  | TActionTeamRosterRequested
  | TActionTeamRosterSucceeded
  | TActionTeamRosterFailed
  | TActionTeamMythicPlusSeasonSet
  | TActionTeamMythicPlusDungeonToggled
  | TActionLoadRecruitmentProfiles
  | TActionLoadRecruitmentProilesSuccess
  | TActionLoadRecruitmentProfilesFail
  | TActionRequestApplication
  | TActionRequestApplicationSuccess
  | TActionRequestApplicationFail
  | TActionSetApplicationMessage
  | TActionSetSourceProfile
  | TActionToggleModalVisibility
  | TActionSetTarget
  | TLocationChange;

export type TActions = {
  setViewTeamLeaderboardRequested(
    instanceId: string,
    params: TViewTeamLeaderboardRequestedParamsData
  ): TActionTeamLeaderboardRequested;
  setViewTeamLeaderboardSucceeded(
    instanceId: string,
    params: TViewTeamLeaderboardSucceededParamsData
  ): TActionTeamLeaderboardSucceeded;
  setViewTeamLeaderboardFailed(
    instanceId: string,
    params: TViewTeamLeaderboardFailedParamsData
  ): TActionTeamLeaderboardFailed;

  setViewTeamDetailsRequested(params: TViewTeamDetailsRequestedParams): TActionTeamDetailsRequested;
  setViewTeamDetailsSucceeded(params: TViewTeamDetailsSucceededParams): TActionTeamDetailsSucceeded;
  setViewTeamDetailsFailed(params: TViewTeamDetailsFailedParams): TActionTeamDetailsFailed;

  setViewTeamRosterRequested(params: TViewTeamRosterRequestedParams): TActionTeamRosterRequested;
  setViewTeamRosterSucceeded(params: TViewTeamRosterSucceededParams): TActionTeamRosterSucceeded;
  setViewTeamRosterFailed(params: TViewTeamRosterFailedParams): TActionTeamRosterFailed;

  setViewTeamMythicPlusProgressRequested(
    params: TViewTeamMythicPlusProgressRequestedParams
  ): TActionTeamMythicPlusProgressRequested;
  setViewTeamMythicPlusProgressSucceeded(
    params: TViewTeamMythicPlusProgressSucceededParams
  ): TActionTeamMythicPlusProgressSucceeded;
  setViewTeamMythicPlusProgressFailed(
    params: TViewTeamMythicPlusProgressFailedParams
  ): TActionTeamMythicPlusProgressFailed;

  setViewTeamMythicPlusCalloutsRequested(
    params: TViewTeamMythicPlusCalloutsRequestedParams
  ): TActionTeamMythicPlusCalloutsRequested;
  setViewTeamMythicPlusCalloutsSucceeded(
    params: TViewTeamMythicPlusCalloutsSucceededParams
  ): TActionTeamMythicPlusCalloutsSucceeded;
  setViewTeamMythicPlusCalloutsFailed(
    params: TViewTeamMythicPlusCalloutsFailedParams
  ): TActionTeamMythicPlusCalloutsFailed;

  setViewTeamMythicPlusRanksRequested(
    params: TViewTeamMythicPlusRanksRequestedParams
  ): TActionTeamMythicPlusRanksRequested;
  setViewTeamMythicPlusRanksSucceeded(
    params: TViewTeamMythicPlusRanksSucceededParams
  ): TActionTeamMythicPlusRanksSucceeded;
  setViewTeamMythicPlusRanksFailed(params: TViewTeamMythicPlusRanksFailedParams): TActionTeamMythicPlusRanksFailed;

  setViewTeamMythicPlusDungeonRequested(
    params: TViewTeamMythicPlusDungeonRequestedParams
  ): TActionTeamMythicPlusDungeonRunsRequested;
  setViewTeamMythicPlusDungeonRunsSucceeded(
    params: TViewTeamMythicPlusDungeonSucceededParams
  ): TActionTeamMythicPlusDungeonRunsSucceeded;
  setViewTeamMythicPlusDungeonRunsFailed(
    params: TViewTeamMythicPlusDungeonFailedParams
  ): TActionTeamMythicPlusDungeonRunsFailed;

  toggleMythicPlusDungeon(params: TViewTeamMythicPlusDungeonRequestedParams): TActionTeamMythicPlusDungeonToggled;

  setMythicPlusSeason(season: string): TActionTeamMythicPlusSeasonSet;

  loadTeamRecruitmentProfiles(): TActionLoadRecruitmentProfiles;
  loadTeamRecruitmentProfileSuccess(profiles: any): TActionLoadRecruitmentProilesSuccess;
  loadTeamRecruitmentProfileFail(): TActionLoadRecruitmentProfilesFail;
  requestApplication(id: number): TActionRequestApplication;
  requestApplicationSuccess(threadId: number): TActionRequestApplicationSuccess;
  requestApplicationFail(msg: string): TActionRequestApplicationFail;
  setApplicationMessage(msg: string): TActionSetApplicationMessage;
  setSourceProfile(sourceProfileId: number): TActionSetSourceProfile;
  toggleApplyModal(): TActionToggleModalVisibility;
  setTarget(targetProfileId: number): TActionSetTarget;
};

export const actions: TActions = {
  // RECRUITMENT
  loadTeamRecruitmentProfiles: () => ({
    type: ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE,
    // reset profiles state, otherwise we'll end up trying to format profiles that
    // aren't relevant and blowing up.
    payload: { loading: true, profiles: [] }
  }),
  loadTeamRecruitmentProfileSuccess: (profiles: any) => ({
    type: ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE_SUCCESS,
    payload: { profiles, loaded: true, loading: false }
  }),
  loadTeamRecruitmentProfileFail: () => ({
    type: ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE_FAIL,
    payload: { error: true, loaded: true }
  }),

  requestApplication: (targetProfileId: number) => ({
    type: ActionTypes.REQUEST_APPLICATION,
    payload: {
      application: {
        loading: true,
        loaded: false,
        error: false
      }
    }
  }),

  requestApplicationSuccess: (threadId: number) => ({
    type: ActionTypes.REQUEST_APPLICATION_SUCCESS,
    payload: {
      application: {
        threadId,
        loading: false,
        loaded: true,
        error: false
      }
    }
  }),
  requestApplicationFail: (errorMessage: string) => ({
    type: ActionTypes.REQUEST_APPLICATION_FAIL,
    payload: {
      errorMessage,
      application: {
        loading: false,
        loaded: true,
        error: true
      }
    }
  }),

  setApplicationMessage: (message: string) => ({
    type: ActionTypes.SET_APPLICATION_MSG,
    payload: { message }
  }),
  setSourceProfile: (sourceProfileId: number) => ({
    type: ActionTypes.SET_SOURCE_PROFILE,
    payload: { sourceProfileId }
  }),

  setTarget: (targetProfileId: number) => ({
    type: ActionTypes.SET_TARGET_PROFILE_ID,
    payload: { targetProfileId }
  }),
  toggleApplyModal: () => ({ type: ActionTypes.TOGGLE_APPLY_MODAL_VISIBILITY, payload: {} }),

  //
  // View Team Leaderboard
  //
  setViewTeamLeaderboardRequested(
    instanceId: string,
    params: TViewTeamLeaderboardRequestedParamsData
  ): TActionTeamLeaderboardRequested {
    return {
      type: ActionTypes.SET_TEAM_LEADERBOARD_REQUESTED,
      payload: {
        instanceId,
        params
      }
    };
  },

  setViewTeamLeaderboardSucceeded(instanceId: string, params: TViewTeamLeaderboardSucceededParamsData) {
    return {
      type: ActionTypes.SET_TEAM_LEADERBOARD_SUCCEEDED,
      payload: {
        instanceId,
        params
      }
    };
  },

  setViewTeamLeaderboardFailed(instanceId: string, params: TViewTeamLeaderboardFailedParamsData) {
    return {
      type: ActionTypes.SET_TEAM_LEADERBOARD_FAILED,
      payload: {
        instanceId,
        params
      }
    };
  },

  //
  // View Team Details
  //
  setViewTeamDetailsRequested(params: TViewTeamDetailsRequestedParams) {
    return { type: ActionTypes.SET_TEAM_DETAILS_REQUESTED, payload: params };
  },

  setViewTeamDetailsSucceeded(params: TViewTeamDetailsSucceededParams) {
    return { type: ActionTypes.SET_TEAM_DETAILS_SUCCEEDED, payload: params };
  },

  setViewTeamDetailsFailed(params: TViewTeamDetailsFailedParams) {
    return { type: ActionTypes.SET_TEAM_DETAILS_FAILED, payload: params };
  },

  //
  // View Team Roster
  //
  setViewTeamRosterRequested(params: TViewTeamRosterRequestedParams) {
    return { type: ActionTypes.SET_TEAM_ROSTER_REQUESTED, payload: params };
  },

  setViewTeamRosterSucceeded(params: TViewTeamRosterSucceededParams) {
    return { type: ActionTypes.SET_TEAM_ROSTER_SUCCEEDED, payload: params };
  },

  setViewTeamRosterFailed(params: TViewTeamRosterFailedParams) {
    return { type: ActionTypes.SET_TEAM_ROSTER_FAILED, payload: params };
  },

  //
  // View Team Mythic+ Progress
  //
  setViewTeamMythicPlusProgressRequested(params: TViewTeamMythicPlusProgressRequestedParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_REQUESTED, payload: params };
  },

  setViewTeamMythicPlusProgressSucceeded(params: TViewTeamMythicPlusProgressSucceededParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_SUCCEEDED, payload: params };
  },

  setViewTeamMythicPlusProgressFailed(params: TViewTeamMythicPlusProgressFailedParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_FAILED, payload: params };
  },

  //
  // View Team Mythic+ Callouts
  //
  setViewTeamMythicPlusCalloutsRequested(params: TViewTeamMythicPlusCalloutsRequestedParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_REQUESTED, payload: params };
  },

  setViewTeamMythicPlusCalloutsSucceeded(params: TViewTeamMythicPlusCalloutsSucceededParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_SUCCEEDED, payload: params };
  },

  setViewTeamMythicPlusCalloutsFailed(params: TViewTeamMythicPlusCalloutsFailedParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_FAILED, payload: params };
  },

  //
  // View Team Mythic+ Ranks
  //
  setViewTeamMythicPlusRanksRequested(params: TViewTeamMythicPlusRanksRequestedParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_REQUESTED, payload: params };
  },

  setViewTeamMythicPlusRanksSucceeded(params: TViewTeamMythicPlusRanksSucceededParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_SUCCEEDED, payload: params };
  },

  setViewTeamMythicPlusRanksFailed(params: TViewTeamMythicPlusRanksFailedParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_FAILED, payload: params };
  },

  //
  // View Team Mythic+ Dungeon
  //
  setViewTeamMythicPlusDungeonRequested(params: TViewTeamMythicPlusDungeonRequestedParams) {
    return { type: ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_REQUESTED, payload: params };
  },

  setViewTeamMythicPlusDungeonRunsSucceeded(params: TViewTeamMythicPlusDungeonSucceededParams) {
    return {
      type: ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_SUCCEEDED,
      payload: params
    };
  },

  setViewTeamMythicPlusDungeonRunsFailed(params: TViewTeamMythicPlusDungeonFailedParams) {
    return {
      type: ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_FAILED,
      payload: params
    };
  },

  setMythicPlusSeason(season: string) {
    return {
      type: ActionTypes.SET_TEAM_MYTHICPLUS_SEASON,
      payload: season
    };
  },

  toggleMythicPlusDungeon(params: TViewTeamMythicPlusDungeonRequestedParams) {
    return {
      type: ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_TOGGLED,
      payload: params
    };
  }
};

//
// Reducer
//

type TTeamLeaderboardData = {
  request: any;
  response: any;
  isRequested: boolean;
  isSucceeded: boolean;
  isErrored: boolean;
};

export function getEmptyTeamLeaderboardState(): TTeamLeaderboardData {
  return {
    request: {},
    response: {},
    isRequested: false,
    isSucceeded: false,
    isErrored: false
  };
}

function getInitialState() {
  return {
    teamMythicPlusSeason: 'season-bfa-4', // FIXME: load properly
    viewTeamLeaderboard: {} as { [key: string]: TTeamLeaderboardData },
    viewTeamDetails: {
      request: {},
      response: {},
      isRequested: false,
      isSucceeded: false,
      isErrored: false
    },
    viewTeamRoster: {
      request: {},
      response: {},
      isRequested: false,
      isSucceeded: false,
      isErrored: false
    },
    teamMythicPlusProgress: {
      request: {},
      response: {},
      isRequested: false,
      isSucceeded: false,
      isErrored: false
    },
    teamMythicPlusCallouts: {
      request: {},
      response: {},
      isRequested: false,
      isSucceeded: false,
      isErrored: false
    },
    teamMythicPlusRanks: {
      request: {},
      response: {},
      isRequested: false,
      isSucceeded: false,
      isErrored: false
    },
    teamMythicPlusDungeons: {
      // will contain an entry for every requested dungeon + team combo
    } as TDict<any>,
    teamMythicPlusDungeonsOpen: {
      // will be filled with boolean values on whether a dungeon is open
    } as TDict<boolean>,
    teamRecruitment: {
      loaded: false,
      loading: false,
      error: false,
      profiles: [],
      message: '',
      applicationModalOpen: false,
      sourceProfileId: -1,
      targetProfileId: -1,
      recruitmentProfileDetails: [],
      errorMessage: '',
      application: {
        loading: false,
        loaded: false,
        error: false,
        threadId: -1
      }
    }
  };
}

type TMakeDungeonKeyParams = {
  season: string;
  region: string;
  team: string;
  dungeon: string;
};

export function makeDungeonKey(params: TMakeDungeonKeyParams) {
  return [params.season, params.region, params.team, params.dungeon].join(':');
}

// identical to charcter, maybe the shared/recruitment folder needs duck so dont
// need to repeat this
/* END RECRUITMENT */

export function reducer(state = getInitialState(), action: TSupportedActions): Partial<TGroupCharterClientState> {
  switch (action.type) {
    // team leaderboard
    case ActionTypes.SET_TEAM_LEADERBOARD_REQUESTED: {
      return {
        ...state,
        viewTeamLeaderboard: {
          ...state.viewTeamLeaderboard,
          [action.payload.instanceId]: {
            ...state.viewTeamLeaderboard[action.payload.instanceId],
            request: action.payload.params,
            isRequested: true,
            isSucceeded: false,
            isErrored: false
          }
        }
      };
    }

    case ActionTypes.SET_TEAM_LEADERBOARD_SUCCEEDED: {
      const { results, ...rest } = action.payload.params;

      const request = {
        ...rest
      };
      return {
        ...state,
        viewTeamLeaderboard: {
          ...state.viewTeamLeaderboard,
          [action.payload.instanceId]: {
            ...state.viewTeamLeaderboard[action.payload.instanceId],
            request,
            response: results,
            isRequested: false,
            isSucceeded: true,
            isErrored: false
          }
        }
      };
    }

    case ActionTypes.SET_TEAM_LEADERBOARD_FAILED: {
      return {
        ...state,
        viewTeamLeaderboard: {
          ...state.viewTeamLeaderboard,
          [action.payload.instanceId]: {
            ...state.viewTeamLeaderboard[action.payload.instanceId],
            isRequested: false,
            isSucceeded: false,
            isErrored: true,
            error: action.payload
          }
        }
      };
    }

    // team details
    case ActionTypes.SET_TEAM_DETAILS_REQUESTED: {
      return {
        ...state,
        viewTeamDetails: {
          ...state.viewTeamDetails,
          request: action.payload,
          isRequested: true,
          isSucceeded: false,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_DETAILS_SUCCEEDED: {
      return {
        ...state,
        viewTeamDetails: {
          ...state.viewTeamDetails,
          response: action.payload.results,
          isRequested: false,
          isSucceeded: true,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_DETAILS_FAILED: {
      return {
        ...state,
        viewTeamDetails: {
          ...state.viewTeamDetails,
          isRequested: false,
          isSucceeded: false,
          isErrored: true,
          error: action.payload
        }
      };
    }

    // team roster
    case ActionTypes.SET_TEAM_ROSTER_REQUESTED: {
      return {
        ...state,
        viewTeamRoster: {
          ...state.viewTeamRoster,
          request: action.payload,
          isRequested: true,
          isSucceeded: false,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_ROSTER_SUCCEEDED: {
      return {
        ...state,
        viewTeamRoster: {
          ...state.viewTeamRoster,
          response: action.payload.results,
          isRequested: false,
          isSucceeded: true,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_ROSTER_FAILED: {
      return {
        ...state,
        viewTeamRoster: {
          ...state.viewTeamRoster,
          isRequested: false,
          isSucceeded: false,
          isErrored: true,
          error: action.payload
        }
      };
    }

    // team mythic plus progress
    case ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_REQUESTED: {
      return {
        ...state,
        teamMythicPlusProgress: {
          ...state.teamMythicPlusProgress,
          request: action.payload,
          isRequested: true,
          isSucceeded: false,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_SUCCEEDED: {
      return {
        ...state,
        teamMythicPlusProgress: {
          ...state.teamMythicPlusProgress,
          response: action.payload.results,
          isRequested: false,
          isSucceeded: true,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_FAILED: {
      return {
        ...state,
        teamMythicPlusProgress: {
          ...state.teamMythicPlusProgress,
          isRequested: false,
          isSucceeded: false,
          isErrored: true,
          error: action.payload
        }
      };
    }

    // team mythic plus callouts
    case ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_REQUESTED: {
      return {
        ...state,
        teamMythicPlusCallouts: {
          ...state.teamMythicPlusCallouts,
          request: action.payload,
          isRequested: true,
          isSucceeded: false,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_SUCCEEDED: {
      return {
        ...state,
        teamMythicPlusCallouts: {
          ...state.teamMythicPlusCallouts,
          response: action.payload.results,
          isRequested: false,
          isSucceeded: true,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_FAILED: {
      return {
        ...state,
        teamMythicPlusCallouts: {
          ...state.teamMythicPlusCallouts,
          isRequested: false,
          isSucceeded: false,
          isErrored: true,
          error: action.payload
        }
      };
    }

    // team mythic plus ranks
    case ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_REQUESTED: {
      return {
        ...state,
        teamMythicPlusRanks: {
          ...state.teamMythicPlusRanks,
          request: action.payload,
          isRequested: true,
          isSucceeded: false,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_SUCCEEDED: {
      return {
        ...state,
        teamMythicPlusRanks: {
          ...state.teamMythicPlusRanks,
          response: action.payload.results,
          isRequested: false,
          isSucceeded: true,
          isErrored: false
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_FAILED: {
      return {
        ...state,
        teamMythicPlusRanks: {
          ...state.teamMythicPlusRanks,
          isRequested: false,
          isSucceeded: false,
          isErrored: true,
          error: action.payload
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_SEASON: {
      return {
        ...state,
        teamMythicPlusSeason: action.payload
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_REQUESTED: {
      const key = makeDungeonKey(action.payload);
      return {
        ...state,
        teamMythicPlusDungeons: {
          ...state.teamMythicPlusDungeons,
          [key]: {
            ...state.teamMythicPlusDungeons[key],
            request: action.payload,
            isRequested: true,
            isSucceeded: false,
            isErrored: false
          }
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_SUCCEEDED: {
      const key = makeDungeonKey(action.payload);
      return {
        ...state,
        teamMythicPlusDungeons: {
          ...state.teamMythicPlusDungeons,
          [key]: {
            ...state.teamMythicPlusDungeons[key],
            response: action.payload.results,
            isRequested: false,
            isSucceeded: true,
            isErrored: false
          }
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_FAILED: {
      const key = makeDungeonKey(action.payload);
      return {
        ...state,
        teamMythicPlusDungeons: {
          ...state.teamMythicPlusDungeons,
          [key]: {
            ...state.teamMythicPlusDungeons[key],
            isRequested: false,
            isSucceeded: false,
            isErrored: true,
            error: action.payload
          }
        }
      };
    }

    case ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_TOGGLED: {
      const key = makeDungeonKey(action.payload);
      return {
        ...state,
        teamMythicPlusDungeonsOpen: {
          ...state.teamMythicPlusDungeonsOpen,
          [key]: !state.teamMythicPlusDungeonsOpen[key]
        }
      };
    }

    case ActionTypes.REQUEST_APPLICATION:
    case ActionTypes.REQUEST_APPLICATION_SUCCESS:
    case ActionTypes.REQUEST_APPLICATION_FAIL:
    case ActionTypes.SET_APPLICATION_MSG:
    case ActionTypes.SET_SOURCE_PROFILE:
    case ActionTypes.SET_TARGET_PROFILE_ID:
    case ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE:
    case ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE_SUCCESS:
    case ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE_FAIL:
      const { teamRecruitment } = state;
      return {
        ...state,
        teamRecruitment: { ...teamRecruitment, ...action.payload }
      };
    case ActionTypes.TOGGLE_APPLY_MODAL_VISIBILITY: {
      const { teamRecruitment: recState } = state;
      const { applicationModalOpen } = recState;

      const nextTeamRecruitmentState = applicationModalOpen
        ? {
            ...state,
            ..._.pick(getInitialState(), [
              'targetProfileId',
              'sourceProfileId',
              'message',
              'errorMessage',
              'application'
            ]),
            applicationModalOpen: false
          }
        : { ...recState, applicationModalOpen: true };

      return {
        ...state,
        teamRecruitment: nextTeamRecruitmentState
      };
    }
    default:
      return state;
  }

  return state;
}
